import { DocPage } from "../components/DocPage";

export const ssr = { mode: "ssg" as const };

export default function Home() {
  return (
    <DocPage
      title="Landrr.js documentation"
      description="Learn how to build fast, SEO-ready React sites with Landrr.js."
    >
      <h1>Documentation</h1>
      <p>
        Landrr.js is a React framework for client sites with Vite, SSR, SSG, and
        built-in SEO helpers.
      </p>
      <h2>Guides</h2>
      <ul>
        <li>Getting started — scaffold and run your first app</li>
        <li>SSR — server-render pages on each request</li>
        <li>SSG — pre-render static HTML at build time</li>
        <li>SEO — meta tags with the Head component</li>
        <li>Deployment — Vercel, Railway, and GitHub Pages</li>
      </ul>
    </DocPage>
  );
}
